import ServiceBase from "../../../servicebase";

export default class VoucherService extends ServiceBase {
  /*
  upsert = (data:IVoucher) : Promise<IResponse<IVoucher>> => 
    this.PostFetch<IResponse<IVoucher>>('entity/voucher', data);
  
  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, creafechaDesde?: string, creafechaHasta?: string, estados?:string, codigo?: string, idioma?: string, vouchertemplate?: string, operacion?: string, clienteNombre?: string, proveedor?: string, producto?: string, activo?: boolean }) : Promise<IPaginatedResponse<any>> => 
    this.GetFetch<IPaginatedResponse<any>>('entity/voucher/find', data);
    
  aprobar = (data: { id:number }) : Promise<IResponse<any>> => 
    this.PostFetch<IResponse<any>>('entity/voucher/aprobar', data);
    
  anular = (data: { id:number }) : Promise<IResponse<any>> => 
    this.PostFetch<IResponse<any>>('entity/voucher/anular', data);
*/
  }
